import { Box } from '@factorialco/deprecated-design-system'

export const Line = () => {
  return (
    <Box
      width="s1"
      height="full"
      background="grey400"
      alignSelf="start"
      position="absolute"
      style={{ left: '9px', top: '16px', zIndex: '1' }}
    />
  )
}
